import { Link } from "react-router-dom";
import type { GoddessCharacter } from "@/mocks/characters";
import { getWork } from "@/mocks/works";

export default function CharacterCard({ c }: { c: GoddessCharacter }) {
  const work = getWork(c.workId);
  return (
    <Link
      to={`/character/${c.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      aria-label={`查看女神角色 ${c.name} 的详细介绍`}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={c.image}
          alt={`${c.name} - ${c.epithet} 女神角色立绘`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800">
          {work?.title}
        </span>
        <div className="absolute inset-x-3 bottom-3">
          <p className="text-xs text-white/80">{c.epithet}</p>
          <div className="mt-1 flex items-center justify-between">
            <h3 className="font-heading text-lg font-bold text-white">{c.name}</h3>
            <span className="flex items-center gap-1 text-xs text-accent-300">
              <i className="ri-heart-3-fill text-accent-400" aria-hidden="true"></i>
              {c.rarity}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}